import React, { useContext } from 'react';
import { InfoIconSmall } from '@domain-group/fe-co-icon';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { MediaContext } from 'react-media-query-hoc';
import { Tooltip } from '@domain-group/fe-blueprint-ui/tooltip';
import moment from 'moment';
import * as styles from './listing-views.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
function timeAgo(date) {
  var input = moment(date);
  if (!input.isValid()) {
    return null;
  }
  if (input.isSame(moment(), 'day')) {
    return 'today';
  }
  return input.fromNow();
}
var ListingViewsNew = props => {
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  return ___EmotionJSX("div", {
    css: styles.listingViews
  }, ___EmotionJSX("div", {
    css: styles.leftSection
  }, ___EmotionJSX("div", {
    css: styles.section
  }, ___EmotionJSX("div", null, "Listing ID:"), ___EmotionJSX("div", null, props.listingId)), ___EmotionJSX("div", {
    css: styles.separator
  }), ___EmotionJSX("div", {
    css: styles.section
  }, ___EmotionJSX("div", null, "Viewed"), ___EmotionJSX("div", null, props.views, " ", props.views === 1 ? 'time' : 'times'))), ___EmotionJSX("div", {
    css: styles.separator
  }), ___EmotionJSX("div", {
    css: styles.section
  }, ___EmotionJSX("div", null, "Last updated:"), ___EmotionJSX("div", {
    css: styles.lastUpdatedValue
  }, props.lastUpdatedNew, ' ', ___EmotionJSX(Tooltip, {
    content: ___EmotionJSX("div", {
      css: styles.firstListedContainer
    }, ___EmotionJSX("div", null, "First listed ", timeAgo(props.dateFirstVisibleDate), " (", props.dateFirstVisible, ")"), ___EmotionJSX("div", {
      css: styles.firstListedFootnote
    }, "* Updates may include changes to the listing details, description, photos, price, paid listing promotions, and more.")),
    placement: mobile ? 'topRight' : 'top',
    maxWidth: 260
  }, ___EmotionJSX(InfoIconSmall, null)))));
};
var ListingViewsOld = props => ___EmotionJSX("div", {
  css: styles.listingViewsOld
}, "Listing ID: ", props.listingId, ". This listing has been viewed ", props.views, ' ', props.views === 1 ? 'time' : 'times', ". It was first displayed on", ' ', props.relistedDate, " and last updated on ", props.lastUpdated, ".");
export var ListingViews = props => {
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var Component = toggledFeatures.NEW_LISTING_VIEWS_BAR ? ListingViewsNew : ListingViewsOld;
  return ___EmotionJSX(Component, props);
};